import { useAuth } from '../hooks/useAuth'

// Direct Stripe payment links
const STRIPE_PRO_LINK = 'https://buy.stripe.com/bJe14p2EO2gN1ni53f9fW00'
const STRIPE_ELITE_LINK = 'https://buy.stripe.com/9B69AVcfoaNj5Dy8fr9fW01'

export default function Settings() {
  const { user } = useAuth()

  return (
    <div>
      <div className="dashboard-header">
        <div>
          <h1 className="dashboard-title">Settings</h1>
          <p className="dashboard-subtitle">Manage your account and subscription</p>
        </div>
      </div>

      {/* Account Section */}
      <section className="settings-section">
        <h2>Account</h2>
        <div className="card">
          <div style={{ display: 'grid', gap: '16px' }}>
            <div>
              <div style={{ fontSize: '13px', color: 'var(--text-dim)', marginBottom: '4px' }}>Email</div>
              <div style={{ color: 'var(--text-bright)' }}>{user?.email}</div>
            </div>
            <div>
              <div style={{ fontSize: '13px', color: 'var(--text-dim)', marginBottom: '4px' }}>Member Since</div>
              <div style={{ color: 'var(--text-bright)' }}>
                {user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Subscription Section */}
      <section className="settings-section">
        <h2>Subscription</h2>
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <div>
              <div style={{ fontSize: '13px', color: 'var(--text-dim)', marginBottom: '4px' }}>Current Plan</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span className={`tier-badge ${user?.tier}`}>
                  {user?.tier?.toUpperCase()}
                </span>
                <span style={{ color: 'var(--text-bright)' }}>
                  {user?.tier === 'free' ? '$0/mo' : user?.tier === 'pro' ? '$10/mo' : '$50/mo'}
                </span>
              </div>
            </div>
            {user?.tier !== 'free' && (
              <span style={{ fontSize: '13px', color: 'var(--text-dim)' }}>
                Email support@alphalens.org to manage subscription
              </span>
            )}
          </div>

          <div style={{
            background: 'var(--bg-primary)',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '24px'
          }}>
            <div style={{ fontSize: '13px', color: 'var(--text-dim)', marginBottom: '8px' }}>
              Daily Usage
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
              <span style={{
                fontSize: '32px',
                fontWeight: '700',
                color: 'var(--text-bright)',
                fontFamily: 'JetBrains Mono'
              }}>
                {user?.daily_deliberations || 0}
              </span>
              <span style={{ color: 'var(--text-dim)' }}>
                / {user?.daily_limit || 1} deliberations today
              </span>
            </div>
          </div>

          {/* Feature comparison */}
          <div>
            <h3 style={{ fontSize: '14px', color: 'var(--text-primary)', marginBottom: '12px' }}>
              Your Plan Includes:
            </h3>
            <ul style={{ listStyle: 'none', display: 'grid', gap: '8px' }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-primary)' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-green)" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Track record access
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-primary)' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-green)" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                {user?.tier === 'free' ? '1 deliberation/day' : 'Unlimited deliberations'}
              </li>
              {user?.tier !== 'free' && (
                <>
                  <li style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-primary)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-green)" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    Full verdict details + actions
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-primary)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-green)" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    Morning briefing
                  </li>
                </>
              )}
              {user?.tier === 'elite' && (
                <>
                  <li style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-primary)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-green)" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    API access
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-primary)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-green)" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    Priority processing
                  </li>
                </>
              )}
            </ul>
          </div>

          {user?.tier === 'free' && (
            <a
              href={`${STRIPE_PRO_LINK}${user?.email ? '?prefilled_email=' + encodeURIComponent(user.email) : ''}`}
              className="btn btn-primary"
              style={{ marginTop: '24px', display: 'inline-flex' }}
            >
              Upgrade to Pro - $10/mo
            </a>
          )}
        </div>
      </section>
    </div>
  )
}
